module.exports = __webpack_public_path__ + "img/MES8Indice3.9eaeae84.png";